'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _form = require('../actions/form');

var initialState = {
  garageId: null,
  serviceIds: [],
  mobilityId: null,
  answers: {},
  day: null,
  hour: null,
  minute: null,
  brandId: 0,
  modelId: 0,
  typeId: 0,
  brand: '',
  model: '',
  type: '',
  mileage: "",
  registerDate: "",
  licensePlate: '',
  fin: '',
  firstName: '',
  lastName: '',
  company: '',
  email: '',
  phone: '',
  message: '',
  isCustomer: false,
  reminderMail: true,
  reminderSMS: false,
  acceptedTos: false,
  isSubmitting: false,
  isSubmitted: false,
  submitFailed: false,
  initialData: {}
};

var formData = function formData() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _form.CONFIGURE:
      return _extends({}, state, action.initialData, {
        initialData: action.initialData
      });

    case _form.FORM_DATA:
      return _extends({}, state, action.data);

    case _form.RESET_STEP:
      switch (action.step) {
        case "garage":
          return _extends({}, state, {
            garageId: null
          });

        case "service":
          return _extends({}, state, {
            serviceIds: []
          });

        case "mobility":
          return _extends({}, state, {
            mobilityId: []
          });

        case "timeslot":
          return _extends({}, state, {
            day: null,
            hour: null,
            minute: null
          });

        case "vehicle":
          return _extends({}, state, {
            brandId: null,
            modelId: null,
            typeId: null
          });

        case "customer":
          return _extends({}, state);
        //TODO: not needed atm
      }

      break;

    case _form.RESET_FORM_DATA:
      return _extends({}, initialState, {
        serviceIds: [],
        answers: {},
        initialData: state.initialData
      });

    default:
      return state;
  }
};

exports.default = formData;